import React from 'react';

import { StyledVideoMiniature } from './VideoMiniature.styles';

import { VideoMiniatureProps } from './VideoMiniature.types';

const VideoMiniature = ({
  handleOpen,
  canClickOnAllTheComponentToOpenVideo = true,
  playButtonSlot = null,
  playButtonChildren = null,
  placeholderSlot = null,
  componentClassname = 'video-miniature',
  customClassnames = '',
  customStyle = '',
}: VideoMiniatureProps) => {
  const buttonsAttributes: React.ButtonHTMLAttributes<HTMLButtonElement> = {
    type: 'button',
    onClick: () => handleOpen(),
  };
  const componentDataBasedOnTag = canClickOnAllTheComponentToOpenVideo
    ? buttonsAttributes
    : {};

  return (
    <StyledVideoMiniature
      as={canClickOnAllTheComponentToOpenVideo ? 'button' : 'div'}
      {...componentDataBasedOnTag}
      className={`${componentClassname} ${
        canClickOnAllTheComponentToOpenVideo
          ? `${componentClassname}--is-button`
          : ''
      } ${customClassnames}`}
      customStyle={customStyle}
    >
      {placeholderSlot && (
        <div className={`${componentClassname}__placeholder`}>
          {placeholderSlot}
        </div>
      )}
      {playButtonSlot ||
        (playButtonChildren && canClickOnAllTheComponentToOpenVideo ? (
          <div className={`${componentClassname}__play-button`}>
            {playButtonChildren}
          </div>
        ) : (
          <button
            className={`${componentClassname}__play-button`}
            {...buttonsAttributes}
          >
            {playButtonChildren}
          </button>
        ))}
    </StyledVideoMiniature>
  );
};
VideoMiniature.displayName = 'VideoMiniature';

export default VideoMiniature;
